import {toFloat, toInt} from '@/lib/helper/helper.js'

export default {
  name: 'AutoUpdateApiData',
  data() {
    return {
      autoUpdateApiDataOptions: {
        timeout  : 10 * 60 * 1000,
        autoStart: true,
        callback : 'getData',
        interval : null
      }
    }
  },
  watch  : {},
  methods: {
    startAutoUpdateApiData(cb, timeout) {
      this.stopAutoUpdateApiData()
      this.autoUpdateApiDataOptions.interval = setInterval(cb, timeout || this.autoUpdateApiDataOptions.timeout)
    },
    stopAutoUpdateApiData() {
      if (this.autoUpdateApiDataOptions.interval) {
        clearInterval(this.autoUpdateApiDataOptions.interval)
      }
    },
    timeoutInMins(minutes = 1) {
      return toFloat(1000 * 60 * toFloat(minutes ?? 1))
    },
    timeoutInSec(seconds = 30) {
      return toInt(1000 * toInt(seconds ?? 30))
    }
  },

  created() {
    if (!this.autoUpdateApiDataOptions.autoStart) return

    if (typeof this.autoUpdateApiDataOptions.callback === 'function') {
      this.startAutoUpdateApiData(this.autoUpdateApiDataOptions.callback)
    } else if (typeof this.autoUpdateApiDataOptions.callback === 'string') {
      if (typeof this[this.autoUpdateApiDataOptions.callback] === 'function') {
        this.startAutoUpdateApiData(this[this.autoUpdateApiDataOptions.callback])
      }
    } else {
      console.warn('AutoUpdateApiData:: No valid callback function passed!')
    }
  },

  beforeDestroy() {
    this.stopAutoUpdateApiData()
  }

}
